export const ERROR_MESSAGE_TITLE = 'Error'
export const FUND_PERFORMANCE_ERROR_MESSAGE_TEXT =
  'Fund Performance information is unavailable at this time. Please try again later.'
export const FUND_LITERATURE_ERROR_MESSAGE_TEXT =
  'Fund Literature is unavailable at this time. Please try again later.'
export const FUND_DETAILS_ERROR_MESSAGE_TEXT =
  'Fund Details information is unavailable at this time. Please try again later.'
